<template>
    <button
        type="button"
        class="px-8 py-1.5 border-2 text-gray-500 border-dashed border-gray-400 bg-transparent rounded-2xl hover:border-gray-600 hover:text-black flex gap-3 items-center"
    >
        <i class="lni lni-reload font-black"></i>
        {{ $trans.get("common.load_more") }}
    </button>
</template>
